/* tslint:disable */
/* eslint-disable */
/**
 * fantasy-dynasty-app
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { NflGame } from '../model';
// @ts-ignore
import { NflPlayerGameStatistics } from '../model';
/**
 * NflGameApi - axios parameter creator
 * @export
 */
export const NflGameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a list of games for a specific season
         * @param {string} playerId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameLog: async (playerId: string, year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('getGameLog', 'playerId', playerId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getGameLog', 'year', year)
            const localVarPath = `/nfl_game/player/{playerId}/season/{year}/gameslog`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of games for a specific season and week
         * @param {number} year 
         * @param {number} week 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGames: async (year: number, week: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getGames', 'year', year)
            // verify required parameter 'week' is not null or undefined
            assertParamExists('getGames', 'week', week)
            const localVarPath = `/nfl_game/season/{year}/week/{week}`
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"week"}}`, encodeURIComponent(String(week)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NflGameApi - functional programming interface
 * @export
 */
export const NflGameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NflGameApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns a list of games for a specific season
         * @param {string} playerId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGameLog(playerId: string, year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NflPlayerGameStatistics>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGameLog(playerId, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns a list of games for a specific season and week
         * @param {number} year 
         * @param {number} week 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGames(year: number, week: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NflGame>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGames(year, week, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NflGameApi - factory interface
 * @export
 */
export const NflGameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NflGameApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns a list of games for a specific season
         * @param {string} playerId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameLog(playerId: string, year: number, options?: any): AxiosPromise<Array<NflPlayerGameStatistics>> {
            return localVarFp.getGameLog(playerId, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of games for a specific season and week
         * @param {number} year 
         * @param {number} week 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGames(year: number, week: number, options?: any): AxiosPromise<Array<NflGame>> {
            return localVarFp.getGames(year, week, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NflGameApi - object-oriented interface
 * @export
 * @class NflGameApi
 * @extends {BaseAPI}
 */
export class NflGameApi extends BaseAPI {
    /**
     * 
     * @summary Returns a list of games for a specific season
     * @param {string} playerId 
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NflGameApi
     */
    public getGameLog(playerId: string, year: number, options?: AxiosRequestConfig) {
        return NflGameApiFp(this.configuration).getGameLog(playerId, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of games for a specific season and week
     * @param {number} year 
     * @param {number} week 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NflGameApi
     */
    public getGames(year: number, week: number, options?: AxiosRequestConfig) {
        return NflGameApiFp(this.configuration).getGames(year, week, options).then((request) => request(this.axios, this.basePath));
    }
}
